import type { AgentScope } from '@/features/agent/AgentChatHost'

/**
 * What the assistant is scoped to on a route: the open case, the lake (`/data`
 * and everything under it), or nothing. The shell mounts the side panel for
 * that scope, so anything that offers the panel asks here too.
 */
export function assistantScopeFor(pathname: string, caseId: string | undefined): AgentScope | null {
  if (caseId) return 'case'
  return pathname === '/data' || pathname.startsWith('/data/') ? 'lake' : null
}

/**
 * Whether the top bar offers the assistant side panel: wherever the assistant
 * has a scope, except on its own full page, which is the same conversation at
 * full width.
 */
export function showsAssistantLauncher(pathname: string, caseId: string | undefined): boolean {
  const onAssistantPage = /\/cases\/[^/]+\/agent(\/|$)/.test(pathname)
  return assistantScopeFor(pathname, caseId) !== null && !onAssistantPage
}
